import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateUserRequest } from "services/management-backend/client";
import { useClientContext } from "clients";
import { useStateContext } from "state";

type updateUserMutationParam = {
  userId: number;
  body: UpdateUserRequest;
};

const useUpdateUser = () => {
  const queryClient = useQueryClient();
  const clients = useClientContext();
  const state = useStateContext();

  const updateUserMutation = useMutation({
    mutationFn: ({ userId, body }: updateUserMutationParam) =>
      clients.management.updateUser(userId, body),
    onSuccess: () => {
      queryClient.invalidateQueries(["listUsers", state.tokens?.user_id]);
    },
  });
  return updateUserMutation;
};

export default useUpdateUser;
